import { keyMirror } from '@tunein/web-utils';

export const errorLabels = keyMirror(
  'missingGuideId',
  'invalidSuccessDeepLinkParamCount',
  'successDeepLinkParamEmpty',
  'errorBulkAddingInterests',
  'errorBulkRemovingInterests',
);
